(function ($) {
  $(function () {

    AOS.init({
      offset: 50,
    });

    /*****
        Set some global variables
    *****/
    const template_url = $('#template_url').val();
    console.log(template_url);


    /*****
        iOS Viewport check
    *****/
    const isVHCheckNeeded = vhCheck();
    const hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
    if (isVHCheckNeeded && hasVHCKeckValue) {
      $('body').addClass('use-ios-offset');
    }


    /*****
        Nav toggle
    *****/
    $('.JS-navToggle').on('click', function (e) {
      e.preventDefault();
      $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
    });

    /*****
        Sub Nav
    *****/

    $('li.menu-item-has-children > a').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('active');
    });



    /*****
       HeaderScrollToggle
   *****/
    function headerScroll() {
      var scroll = $(window).scrollTop();
      if (scroll >= 20) {
        //clearHeader, not clearheader - caps H
        $(".header").addClass("header--scrolled");
      } else {
        $(".header").removeClass("header--scrolled");
      }
    }

    $(document).ready(function () {
      headerScroll()
    });

    $(window).scroll(function () {
      headerScroll()
    }); //missing );

    /*****
        ScrollToggle
    *****/
    $('.JS-scrollToggle').on('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: document.getElementById('page-header').offsetHeight, behavior: 'smooth' });
    });


    /*****
        InitSlickSliders
    *****/
    $('.slick-slider-news').each(function () {
      $(this).slick({
        infinite: true,
        mobileFirst: true,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px',

        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              centerPadding: '0px',
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              centerPadding: '0px',
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              centerPadding: '0px',
            }
          }

        ]
      })
    });

    $('.slick-slider-video').each(function () {
      $(this).slick({
        infinite: true,
        mobileFirst: true,
        dots: false,
        arrows: true,
        centerPadding: '20px',
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        prevArrow: $(this).parent().find('.prev_arrow'),
        nextArrow: $(this).parent().find('.next_arrow'),
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              centerPadding: '40px'
            }
          },
          {
            breakpoint: 1025,
            settings: {
              centerPadding: '80px'
            }
          },
          {
            breakpoint: 1100,
            settings: {
              centerPadding: '125px',
            }
          }

        ]
      })
    });

    $('.grid').imagesLoaded(function () {
      $('.grid').colcade({
        columns: '.grid-col',
        items: '.grid-item'
      });
    });



  });
})(jQuery);
